/** @jsx jsx */

/** @jsxFrag */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography2 } from '@coursera/cds-core';

import EoiButtonsShared from 'bundles/degree-description/components/modules/expression-of-interest/EoiButtonsShared';
import Container from 'bundles/degree-description/components/shared/Container';
import type { EoiTextType } from 'bundles/degree-description/utils/EoiUtils';
import type { EoiButtonsType } from 'bundles/expression-of-interest/types';

type Props = {
  partnerLogoUrl?: string;
  partnerName?: string;
  programName?: string;
  eoiButtons?: EoiButtonsType;
  eoiContainerText?: EoiTextType;
  isFixed?: boolean;
  setEoiTrackingIndex?: React.Dispatch<React.SetStateAction<number>>;
};

const styles = {
  fixedHeader: css`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 80px;
    background-color: var(--cds-color-neutral-background-primary);
    z-index: 6;
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    padding: var(--cds-spacing-200);
    transition: top 0.3s;
  `,
  hide: css`
    visibility: hidden;
    position: fixed;
    top: -500px;
    transition: top 0.3s;
  `,
};

const EoiHeaderButtons = ({
  partnerLogoUrl,
  partnerName,
  programName,
  eoiButtons,
  eoiContainerText,
  isFixed,
  setEoiTrackingIndex,
}: Props) => {
  if (!eoiButtons) {
    return null;
  }
  return (
    <div css={isFixed ? styles.fixedHeader : styles.hide} data-testid="eoi-header-buttons">
      <Container>
        <Grid container spacing={16}>
          <Grid item container xs={6} spacing={16} alignItems="center" alignContent="center">
            {partnerLogoUrl && partnerName && (
              <Grid item>
                <Imgix
                  src={partnerLogoUrl}
                  alt={partnerName ? `${partnerName} logo` : 'Partner'}
                  maxWidth={48}
                  maxHeight={48}
                />
              </Grid>
            )}
            {programName && (
              <Grid item>
                <Typography2 component="h3" variant="subtitleMedium">
                  {programName}
                </Typography2>
              </Grid>
            )}
          </Grid>
          <Grid item container xs={6} spacing={16} justifyContent="flex-end">
            <EoiButtonsShared
              keySuffix="-eoi-header-overview-button"
              eoiButtons={eoiButtons}
              eoiContainerText={eoiContainerText}
              trackingNamePrefix="desktop_sticky_header"
              trackingIndex={1}
              setEoiTrackingIndex={setEoiTrackingIndex}
              enableGrid
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default EoiHeaderButtons;
